import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app/app.module';

import 'codemirror/mode/css/css';
import 'codemirror/mode/markdown/markdown';
import 'codemirror/mode/javascript/javascript';

import 'codemirror/addon/fold/foldgutter';
import 'codemirror/addon/fold/brace-fold';

import 'codemirror/addon/edit/closebrackets';
import 'codemirror/addon/edit/matchbrackets';

import 'ag-grid-enterprise';
import {environment} from './environments/environment';
import {LicenseManager} from 'ag-grid-enterprise';
import {AG_GRID_LICENSE, SentryConfigurator} from '@pt/pt-core';

import * as Sentry from "@sentry/angular";
import { LogLevel } from 'it/primatoo/openapi/api/common/schemas/LogLevel';
(window as any).logLevel = LogLevel.OFF;


if (environment.production) {
  enableProdMode();
  LicenseManager.setLicenseKey(AG_GRID_LICENSE);
}

Sentry.init(SentryConfigurator.buildBrowserConfig({
  sentryProjectName: 'primatoo-ui',
  dsn: 'https://9b307fa6d68047d0ad8641f3a7c805f9@sentry.gfm.cloud/7'
}));

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
